export const languages = [
  { code: 'zh', name: '中文(简体)' },
  { code: 'zh-Hant', name: '正體中文(繁體)' },
  { code: 'en', name: 'English (US)' },
];

export const DEFAULT_LANGUAGE = 'zh';

export function normalizeLanguage(code) {
  return languages.some(language => language.code === code) ? code : '';
}

export function detectLanguage() {
  if (typeof navigator === 'undefined') return DEFAULT_LANGUAGE;
  const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const item of browserLanguages) {
    const tag = String(item || '').toLowerCase().replace(/_/g, '-');
    if (tag === 'zh-tw' || tag === 'zh-hk' || tag === 'zh-mo' || tag.startsWith('zh-hant')) {
      return 'zh-Hant';
    }
    const shortCode = tag.split('-')[0];
    const matched = normalizeLanguage(shortCode);
    if (matched) return matched;
  }
  return DEFAULT_LANGUAGE;
}
